import { useTrialModalClosedLocalStorageKeyName } from 'features/forceTrial/useTrialModalClosedLocalStorageKeyName';

export type TrialModalState = 'never_shown' | 'should_not_show' | 'should_show';

const timeToShowTrialModalInHours = 48;

export const useHasTrialModalBeenClosedSomeTimeAgo = (): TrialModalState => {
  const modalClosedAtKey = useTrialModalClosedLocalStorageKeyName();

  const closedAt = localStorage.getItem(modalClosedAtKey);

  if (!closedAt) {
    return 'never_shown';
  }

  const closedAtMS = parseInt(closedAt, 10);
  const now = Date.now();

  const xHoursAgo = now - timeToShowTrialModalInHours * 60 * 60 * 1000;

  return closedAtMS > xHoursAgo ? 'should_not_show' : 'should_show';
};
